import { Component, OnInit, Inject, Input, SimpleChanges, AfterViewInit, ViewChild } from '@angular/core';
import { ConfigDataService } from '../../../../services/config-data.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { Concepto } from '../../../../models/concepto';
import { Moneda } from '../../../../models/moneda';
import { SueldoBasicoService } from '../../../../services/sueldo-basico.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ErroresService } from '../../../../core/services/errores.service';
import { CodigoNomina } from '../../../../models/codigo-nomina';
import { CodigosNominaService } from '../../../../services/codigosNomina.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-sueldo-editar-dialog',
  templateUrl: './sueldo-editar-dialog.component.html',
  styleUrls: ['./sueldo-editar-dialog.component.css']
})
export class SueldoEditarDialogComponent implements OnInit, AfterViewInit
{
  MensajeError: string = '';
  monedasList: any;
  codigosNominaList:any;
  registerForm: FormGroup;
  submitted = false;
  guardando: boolean;
  conceptoInvalido: boolean;
  @Input() disabledEditing: boolean;
  EsEdicion: boolean;
  actualizarFormatoInputNumerico = true;
  tipoCarga: number;

  constructor(public dialogRef: MatDialogRef<any>, 
              @Inject(MAT_DIALOG_DATA) public data: any, 
              private configDataSrv: ConfigDataService, 
              private fb: FormBuilder, 
              private codigosNominaService: CodigosNominaService,
              private sueldoBasicoService: SueldoBasicoService, 
              private dialog: MatDialog, 
              private erroresService: ErroresService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.tipoCarga = 0;
    this.codigosNominaService.getAll().subscribe(
      codigos => 
      { 
        codigos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        this.codigosNominaList = codigos;
        this.codigosNominaList = this.codigosNominaList && this.codigosNominaList.filter(items => items.sueldoBasico == true &&
                                                                                        Date.parse(items.desde) <= Date.parse(this.data.desde) &&
                                                                                        Date.parse(items.hasta) >= Date.parse(this.data.desde)) ;
        this.getTipoCargaCodigoNomina(this.data.param.codigoNomina);
      });
    this.monedasList = this.data.monedasList;

    this.configurarValidadores();

    this.configDataSrv.getSueldos().subscribe(
      data =>
    {
      this.registerForm.controls['id'].setValue(this.data.param.id);
      this.registerForm.controls['idSueldoBasico'].setValue(this.data.param.idSueldoBasico);
      this.registerForm.controls['moneda'].setValue(this.data.param.moneda);
    },
    error =>
    {
      console.log(error);
    });
  }

  configurarValidadores(): void
  {
    this.registerForm = this.fb.group({
      id: ['', Validators.required],
      idSueldoBasico: ['', Validators.required],
      codigoNomina: ['', Validators.required],
      cantidad: [''],     
      importe: [''],
      moneda: [''],
    });
  }

  get registerFormControl()
  {
    return this.registerForm.controls;
  }

  ngAfterViewInit()
  {
    if (this.data.param.id != 0)
    {
      this.registerForm.patchValue(this.data.param);
      this.EsEdicion = true;
      this.actualizarFormatoInputNumerico = true;
    }
  }

  getTipoCargaCodigoNomina(nomina:number){
    this.tipoCarga = 0;
    if (nomina != null) {
      this.tipoCarga = this.codigosNominaList.find(m => m.id == nomina).tipoCarga;
    }
    if (this.tipoCarga == 2) 
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', Validators.required);
    } else if (this.tipoCarga == 1)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
      this.setValidatorRequired('cantidad', null);
    } else if (this.tipoCarga == 3)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('cantidad', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
    } else
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', null);
    }
  }

  setValidatorRequired(campo, requerido) {
    this.registerForm.controls[campo].setValidators(requerido);
    this.registerForm.controls[campo].updateValueAndValidity();
  }

  onChangeCodigoNomina(event) {
    this.getTipoCargaCodigoNomina(event.value);

    if (this.tipoCarga == 2) 
    {
      this.registerForm.controls['importe'].setValue(0);
      this.registerForm.controls['moneda'].setValue(1);
    } else if (this.tipoCarga == 1)
    {
      this.registerForm.controls['cantidad'].setValue(0);
    } else if (this.tipoCarga == 4)
    {
      this.registerForm.controls['importe'].setValue(0);
      this.registerForm.controls['moneda'].setValue(1);
      this.registerForm.controls['cantidad'].setValue(0);
    }
  }

  onSubmit(): void
  {
    this.submitted = true;
    if (this.registerForm.valid)
    {
      let concepto: Concepto = {
        id: this.registerForm.value.id,
        idSueldoBasico: this.registerForm.value.idSueldoBasico,
        cantidad: this.registerForm.value.cantidad,
        codigoNomina: this.registerForm.value.codigoNomina,
        importe: this.registerForm.value.importe,
        moneda: this.registerForm.value.moneda,
        modificadoManualmente: true
      };
      if (this.tipoCarga == 2) {
        concepto.importe = 0
      } else {
        // let decimal: FormatearImportePipe = new FormatearImportePipe();
        // concepto.importe = decimal.transform(concepto.importe);
      }
      
      if (concepto.idSueldoBasico == 0)
      {
        let monedaN = this.monedasList.find(m => m.id == concepto.moneda);
        let monedaSeleccionada: Moneda = { id: monedaN.id, codigo: monedaN.codigo, descripcion: monedaN.descripcion };
        concepto.monedaNavigation = monedaSeleccionada;

        let codigoNominaN = this.codigosNominaList.find(m => m.id == concepto.codigoNomina);
        let codigoSeleccionado: CodigoNomina = { id: codigoNominaN.id, codigo: codigoNominaN.codigo, descripcion: codigoNominaN.descripcion };
        concepto.codigoNominaNavigation = codigoSeleccionado;

        concepto.id = Math.random() * -1;

        this.dialogRef.close(concepto);
        return;
      }

      this.guardando = true;

      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      this.sueldoBasicoService.guardarConcepto(concepto).subscribe(
        resu =>
        {

          let monedaN = this.monedasList.find(m => m.id == resu.moneda);
          let monedaSeleccionada: Moneda = { id: monedaN.id, codigo: monedaN.codigo, descripcion: monedaN.descripcion };
          resu.monedaNavigation = monedaSeleccionada;

          let codigoNominaN = this.codigosNominaList.find(m => m.id == resu.codigoNomina);
          let codigoSeleccionado: CodigoNomina = { id: codigoNominaN.id, codigo: codigoNominaN.codigo, descripcion: codigoNominaN.descripcion };
          resu.codigoNominaNavigation = codigoSeleccionado;

          setTimeout(function ()
          {
            this.guardando = false;
            dialogProcesandoRef.close();
          });

          this.dialogRef.close(resu);
        },
        error =>
        {
          this.guardando = false;
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.conceptoInvalido = true;
            
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
    else
    {
      this.registerForm.markAllAsTouched();
    }
  }

  cancelar(): void
  {
    this.dialogRef.close(null);
  }
}
